export const GMCC_ASSET_VERSION = "20250420";

export const getCacheBustedUrl = (path) => {
    return `/${GMCC_ASSET_VERSION}${path}`;
}

export const FLYER_URL_PREFIX = "https://gmcc-files.s3.us-west-1.amazonaws.com/gmccflyers";

export const getS3Url = (path) => {
    let strippedPath = path.replace("/images/gmccflyers/", "");
    return `${FLYER_URL_PREFIX}/${strippedPath}`;
}

export const FLYER_RATE_SETUP_URL_MAP = {
    "jumbocra": `${FLYER_URL_PREFIX}/Custom_JumboCRA.png`,
    "template_jumbocra": `${FLYER_URL_PREFIX}/Custom_Template_JumboCRA.png`,
    "ocean": `${FLYER_URL_PREFIX}/Custom_Ocean.png`,
    "template_ocean": `${FLYER_URL_PREFIX}/Custom_Template_Ocean.png`,
    "fabulous": `${FLYER_URL_PREFIX}/Custom_Fabulous.png`,
    "template_fabulous": `${FLYER_URL_PREFIX}/Custom_Template_Fabulous.png`,
    "amazing": `${FLYER_URL_PREFIX}/Custom_Amazing.png`,
    "template_amazing": `${FLYER_URL_PREFIX}/Custom_Template_Amazing.png`,
    "40down": `${FLYER_URL_PREFIX}/Custom_40Down.png`,
    "template_40down": `${FLYER_URL_PREFIX}/Custom_Template_40Down.png`,
    "thunder": `${FLYER_URL_PREFIX}/Custom_Thunder.png`,
    "template_thunder": `${FLYER_URL_PREFIX}/Custom_Template_Thunder.png`,
    "hermes": `${FLYER_URL_PREFIX}/Custom_hermes.png`,
    "template_hermes": `${FLYER_URL_PREFIX}/Custom_Template_hermes.png`,
    "radiant": `${FLYER_URL_PREFIX}/Custom_Radiant.png`,
    "template_radiant": `${FLYER_URL_PREFIX}/Custom_Template_Radiant.png`,
}

export const FLYER_RATE_SETUP_NAMES_MAP = {
    "jumbocra": {
        regular: ["GMCC_JumboCRAFlyer_zeitro", "Template_JumboCRA"],
        letterSize: ["22_JumboCRA", "Template_22_JumboCRA"]
    },
    "ocean": {
        regular: ["GMCC_OceanFlyer_zeitro", "Template_Ocean"],
        letterSize: ["25_GMCCOcean", "Template_25_GMCCOcean"]
    },
    "fabulous": {
        regular: ["GMCC_FabulousFlyer_zeitro", "Template_Fabulous"],
        letterSize: ["27_GMCCFabulous", "Template_27_GMCCFabulous"]
    },
    "amazing": {
        regular: [],
        letterSize: ["30_Amazing", "Template_30_Amazing"]
    },
    "40down": {
        regular: ["GMCC_40downFlyer_zeitro", "Template_40down"],
        letterSize: ["05_40PercentDownNoIncome", "Template_05_40PercentDownNoIncome"]
    },
    "thunder": {
        regular: ["GMCC_ThunderFlyer_zeitro", "Template_Thunder"],
        letterSize: ["32_Thunder", "Template_32_Thunder"]
    },
    "hermes": {
        regular: ["GMCC_HermesFlyer_zeitro", "Template_hermes"],
        letterSize: ["07_GMCCHermesAlternatives", "Template_07_GMCCHermesAlternatives"]
    },
    "radiant": {
        regular: ["GMCC_RadiantFlyer_zeitro", "Template_radiant"],
        letterSize: ["02_GMCCNoRatioRadiant", "Template_02_GMCCNoRatioRadiant"]
    },
    "ratesheet_universe": {
        regular: ["Ratesheet_Universe"],
        letterSize: [],
    },
    "ratesheet_radiant": {
        regular: ["Ratesheet_Radiant"],
        letterSize: [],
    },
    "ratesheet_hermes": {
        regular: ["Ratesheet_Hermes"],
        letterSize: [],
    },
    "ratesheet_ocean": {
        regular: ["Ratesheet_Ocean"],
        letterSize: [],
    },
    "ratesheet_outreach": {
        regular: ["Ratesheet_Outreach"],
        letterSize: [],
    },
}
